import React from 'react';
import LegalPage from '../components/LegalPage';

const LegalNotice = () => (
  <LegalPage
    testId="page-legal"
    metaTitle="Aviso Legal | VIDAT"
    title="Aviso Legal"
    subtitle="Información legal sobre el titular de la web."
    sections={[
      {
        title: 'Titular de la web',
        body: [
          'El titular de esta página web es:',
          { type: 'block', lines: [
            'VIDAT INSTITUTO DE INTELIGENCIA MEDICA, S.L.',
            'Local 6, Carrer de Pau Muñoz i Castanyer, 12, 08174 Sant Cugat del Vallès, Barcelona.',
            'Correo electrónico de contacto: info@vidat.cat',
            'Dominio: vidat.cat',
          ] },
        ],
      },
      {
        title: 'Objeto de la web',
        body: [
          'La presente web tiene como finalidad ofrecer información sobre VIDAT, Instituto de Inteligencia Médica, sus servicios sanitarios, su metodología de trabajo y sus canales de contacto.',
          'La información publicada en esta web tiene carácter informativo y no sustituye una valoración médica individualizada.',
        ],
      },
      {
        title: 'Condiciones de uso',
        body: [
          'La persona usuaria se compromete a utilizar esta web de forma lícita, adecuada y respetuosa con la normativa vigente, la buena fe y el orden público.',
          'No está permitido utilizar la web con fines ilícitos, fraudulentos o que puedan dañar la imagen, intereses o derechos de VIDAT o de terceros.',
        ],
      },
      {
        title: 'Información sanitaria',
        body: [
          'Los contenidos publicados en esta web tienen una finalidad informativa y divulgativa. No constituyen diagnóstico, tratamiento ni recomendación médica personalizada.',
          'Para cualquier problema de salud, la persona usuaria debe consultar con un profesional sanitario cualificado.',
        ],
      },
      {
        title: 'Propiedad intelectual',
        body: [
          'Los contenidos de esta web, incluyendo textos, diseño, estructura, imágenes, logotipo, elementos gráficos y demás materiales, pertenecen a VIDAT o se utilizan con autorización.',
          'No está permitida su reproducción, distribución o modificación sin autorización previa.',
        ],
      },
      {
        title: 'Responsabilidad',
        body: [
          'VIDAT procura que la información publicada en esta web sea clara, actualizada y correcta. No obstante, no se garantiza la ausencia de errores u omisiones.',
          'VIDAT podrá modificar, actualizar o retirar contenidos de la web en cualquier momento.',
        ],
      },
      {
        title: 'Enlaces externos',
        body: [
          'La web puede contener enlaces a páginas de terceros. VIDAT no se responsabiliza del contenido, funcionamiento o políticas de privacidad de dichas páginas externas.',
        ],
      },
      {
        title: 'Protección de datos y cookies',
        body: [
          'El tratamiento de datos personales se regula en la Política de Privacidad.',
          'El uso de cookies se regula en la Política de Cookies.',
          'Ambos documentos estarán disponibles mediante enlaces permanentes en el footer de la web.',
        ],
      },
    ]}
  />
);

export default LegalNotice;
